const initialState = {
  loading: false
};

const charity = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_STATS_FOR_SCHOOL_MAIN_REQUEST':
    case 'GET_STATS_FOR_SCHOOL_MAIN_SUCCESS':
    case 'GET_STATS_FOR_SCHOOL_MAIN_FAILED':
    case 'GET_FEATURED_CHARITY_FOR_CHARITY_MAIN_SUCCESS':
    case 'GET_FEATURED_CHARITY_FOR_CHARITY_MAIN_FAILED':
    case 'GET_FEATURED_CHARITY_FOR_CHARITY_MAIN_REQUEST':
    case 'GET_RECENT_CAUSES_FOR_CHARITY_MAIN_FAILED':
    case 'GET_RECENT_CAUSES_FOR_CHARITY_MAIN_REQUEST':
    case 'GET_RECENT_CAUSES_FOR_CHARITY_MAIN_SUCCESS': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default charity;
